import { ReactNode } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { Label as LabelStyle } from '@r1-frontend/ui-react/components/label/styled';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { BlockContainer, NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { createGradient } from './helpers/gradient';

interface IImageSource {
    src?: string,
    webpSrc?: string,
}

type TPromoLabel = {
    children: ReactNode,
    title: string,

    borderColors?: string[] | null,
    backgroundColors?: string[] | null,

    titleColor?: string,

    image?: IImageSource,

    className?: string,
}

/**
 * Добавляет компоненту обертку в виде промо-лейбла и обводки
 *
 * {@link https://www.figma.com/design/dZ9nsGKTEkHJJGcfuP8pRi/%F0%9F%8D%8FDS-WEB?node-id=14405-13534&t=mcVQofYjbetgq4lH-0 Figma}
 */
const WithPromoLabel = (
    {
        title,
        titleColor = COLORS.TextWhite,

        image,

        className,
        children,
    }: TPromoLabel,
) => {
    const hasImg = !!(image?.src);

    return (
        <NonStaticContainer
            className={className}
            $united={{
                $position: 'relative',
            }}
        >
            <NonStaticContainer
                $united={{
                    $position: 'absolute',
                    $top: -16,
                }}
            >
                <BlockContainer
                    rounder={{ $radius: 16 }}
                    indent={{ $united: hasImg ? [8, 64, 8, 0] : [8, 0] }}
                >
                    <Label
                        textColor={titleColor}
                        bgColor={'transparent'}
                    >
                        {title}
                    </Label>

                    {hasImg && <NonStaticContainer
                        $united={{
                            $position: 'absolute',
                            $right: 0,
                            $bottom: 0,
                        }}
                    >
                        <WebpImage urlWebp={image.webpSrc}>
                            <LazyLoadImage
                                width={64}
                                height={40}
                                src={image.src}
                            />
                        </WebpImage>
                    </NonStaticContainer>}
                </BlockContainer>

            </NonStaticContainer>
            {children}
        </NonStaticContainer>
    );
};

export default styled(WithPromoLabel)<{ $radius?: BorderRadius }>`
    --border-width: 2px;

    border: var(--border-width) solid transparent;
    border-radius: ${({ $radius = BorderRadius.OuterBlockRadius }) => `calc(${$radius} + var(--border-width))`};
    
    background:
        linear-gradient(white, white) padding-box, 
        ${props => createGradient(props.borderColors)} border-box;
    
    & > ${NonStaticContainer} {
        display: flex;
        width: 208px;
    
        left: 50%;
        transform: translateX(-50%);
    
        ${LabelStyle} {
            width: 100%;
            padding: 0;
        }
    
        ${BlockContainer} {
            background: ${props => createGradient(props.backgroundColors)};
            
            picture {
                width: 64px;
                height: 40px;
            }
        }
    }
`;
